export default Symbol('animationWrapper')



// WEBPACK FOOTER //
// ./src/js/util/symbols/animationWrapper.js